import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";

export const CallButton = ({ id = "call-btn", className = "" }) => (
  <a
    href={SITE.tel}
    data-testid={id}
    className={`group inline-flex items-center gap-3 rounded-full bg-hibiscus px-6 py-3.5 font-semibold text-cream shadow-[0_10px_30px_-10px_rgba(210,70,43,0.8)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#B83A22] active:scale-95 ${className}`}
  >
    <span className="grid h-7 w-7 place-items-center rounded-full bg-cream/15 transition-transform duration-500 group-hover:rotate-[20deg]">
      <Phone className="h-4 w-4" />
    </span>
    Call {SITE.phone}
  </a>
);

export const DirectionsButton = ({ id = "directions-btn", className = "", dark = false }) => (
  <a
    href={SITE.directions}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={id}
    className={`group inline-flex items-center gap-3 rounded-full border px-6 py-3.5 font-semibold transition-[transform,background-color,color] duration-300 hover:-translate-y-0.5 active:scale-95 ${
      dark
        ? "border-cocoa/25 text-cocoa hover:bg-cocoa hover:text-cream"
        : "border-cream/30 text-cream hover:bg-cream hover:text-cocoa"
    } ${className}`}
  >
    <MapPin className="h-4 w-4" />
    Get Directions
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);

export const CTAPair = ({ prefix = "cta", dark = false, className = "" }) => (
  <div className={`flex flex-wrap gap-3 ${className}`}>
    <CallButton id={`${prefix}-call-btn`} />
    <DirectionsButton id={`${prefix}-directions-btn`} dark={dark} />
  </div>
);
